import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export default function Home(){
  const { t } = useTranslation()
  return (
    <main>
      <Helmet><title>{t('home.title')}</title></Helmet>

      {/* HERO */}
      <section className="hero-new">
        <div className="hero-content">
          <img src="/images/logo-removebg-preview (1).png" alt="Pearl of Galia logo" className="hero-logo" />
          <div className="hero-text">
            <h1 className="hero-title">
              <span>PEARL OF GALIA</span>
            </h1>
            <p className="hero-subtitle">{t('home.hero.subtitle')}</p>
            <div className="hero-actions">
              <Link to="/contact#contact-form" className="btn btn-primary">{t('cta.contact')}</Link>
              <Link to="/about" className="btn btn-secondary">{t('cta.learn')}</Link>
            </div>
          </div>
        </div>
      </section>


      {/* PRODUCT PREVIEW */}
      <section className="product-preview">
        <div className="container">
          <h2 className="section-title">{t('home.products.title')}</h2>
          <div className="preview-grid">
            <div className="preview-card">
              <img src="/images/matcha-removebg-preview.png" alt="Ceremonial Matcha" />
              <h3>{t('nav.matcha')}</h3>
              <p>{t('home.preview.matcha.desc')}</p>
              <Link to="/matcha" className="btn btn-outline">{t('cta.learn')}</Link>
            </div>
            <div className="preview-card">
              <img src="/images/caviar-removebg-preview.png" alt="Premium Caviar" />
              <h3>{t('nav.caviar')}</h3>
              <p>{t('home.preview.caviar.desc')}</p>
              <Link to="/caviar" className="btn btn-outline">{t('cta.learn')}</Link>
            </div>
          </div>
        </div>
      </section>

    </main>
  )
}
